import { Notifications } from "@scrile/api-provider/dist/lib/Notifications";
import {
  isIOS,
  isMobile,
  isSafari,
  isMacOS,
  isIOSWebView,
  isAndroidWebView,
} from "@scrile/tools/dist/lib/browserUtils";
export const IS_BROWSER = process.env.VUE_APP_SERVER === "false";
export { isIOS, isMobile, isSafari, isMacOS, isIOSWebView, isAndroidWebView };
export const isWebApp = (navigator as any).standalone;

export function iosVersion(): {
  status: boolean;
  version: number;
  info: string;
} {
  if (!isIOS()) {
    return {
      status: false,
      version: 0,
      info: "",
    };
  }
  const result = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);

  return {
    status: true,
    version: parseInt(result?.[1] ?? "0", 10),
    info:
      parseInt(result?.[1] ?? "0", 10) +
      "." +
      parseInt(result?.[2] ?? "0", 10) +
      "." +
      parseInt(result?.[3] ?? "0", 10),
  };
}

export const isNotificationsSupported = () =>
  "Notification" in window && "serviceWorker" in navigator && "PushManager" in window;
export const getNotificationsPermissions = () => {
  if (!isNotificationsSupported()) {
    return "default";
  }
  return Notification.permission;
};
